// extracted by mini-css-extract-plugin
export default {"defaultMargin":"VKK1QDT349_mfD7_KyyM","slider":"E_rxhtPS9ybSXYQ9Kwf0"};